import * as Sentry from "@sentry/react";

export interface Job {
  fn: (...args: any[]) => Promise<void>;
  parameters: any[]
}

class AsyncExecutionQue {
  private pendingJobs: Array<Job>;
  private status: "running" | "idle";


  constructor() {
    this.pendingJobs = [];
    this.status = "idle";
  }

  private async executionLoop() {
    this.status = "running";
    while (this.pendingJobs.length > 0) {
      try {
        const job = this.pendingJobs.shift()!;
        await job.fn(...job.parameters);

      } catch (e) {
        Sentry.captureException(e);
      }
    }
    this.status = "idle";
  }

  public submit(job: Job) {
    this.pendingJobs.push(job);
    if (this.status === "idle") {
      this.executionLoop();
    }
  }

  public getPendingJobs() {
    return this.pendingJobs
  }

  public getStatus() {
    return this.status;
  }
}

export const asyncExecutionQue = new AsyncExecutionQue();